const domains = {
    url: '',
    auth: `https://${(process.env.REACT_APP_DEBUG || window.location.origin.includes('dev-')) ? 'dev-' : ''}auth.ayomi.fr`,
};
export default domains;
